/**
 * Public API Service
 * Handles public API calls that don't require authentication
 */

import { API_URL } from '../env'

export interface DomainLookupResponse {
  found: boolean
  agentId?: string
  teamId?: string
  isAppDomain?: boolean
  /** Workspace slug that owns the agent domain — used to start the SSO flow. */
  workspaceSlug?: string | null
  /** Whether the owning workspace has SSO enabled (offer SSO sign-in). */
  ssoEnabled?: boolean
  /** SSO enforcement: "optional" | "required" (drives auto-redirect). */
  ssoEnforcement?: string | null
  error?: string
}

/**
 * Public API client for unauthenticated endpoints
 */
export const publicApi = {
  /**
   * Look up if a domain is attached to an agent
   * Used for domain-based routing on app load
   * @param domain - Domain name to lookup
   * @returns Promise resolving to lookup result
   */
  async lookupDomain(domain: string): Promise<DomainLookupResponse> {
    try {
      // Use full backend URL to avoid calling frontend domain
      const response = await fetch(
        `${API_URL}/public/domain-lookup?domain=${encodeURIComponent(domain)}`
      )

      if (!response.ok) {
        return { found: false, error: 'Network error' }
      }

      const data = await response.json()
      return data.data || { found: false }
    } catch {
      return { found: false, error: 'Request failed' }
    }
  }
}
